<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-15 11:31:07
-->
<template>
  <div class="bg">
    <RenewalUpgrade style="margin-top:182px" @selectedByValue="selectedByValue"/>
    <Footer @handleToPay="handleToPay" :payInfo="payInfo"/>
    <PayModal ref="payModal" :payInfo="payInfo"/>
    <UserInfoModal ref="UserInfoModal" :payInfo="payInfo" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PayModal from '@/components/modal/payModal.vue';
import RenewalUpgrade from './components/renewalUpgrade.vue';
import UserInfoModal from './components/modal/userInfo.vue';
import Footer from './components/footer.vue';

export default defineComponent({
  name: 'CostMode',
  components: {
    RenewalUpgrade,
    Footer,
    PayModal,
    UserInfoModal,
  },
  data() {
    return {
      payInfo: {
        key: '',
      },
    };
  },
  methods: {
    selectedByValue(value: TString) {
      console.log('===>', value);
      this.payInfo = value as never;
    },
    handleToPay() {
      if (this.payInfo.key >= '4') {
        const refs = this.$refs as unknown as {UserInfoModal: {showModal: Function}};
        refs.UserInfoModal.showModal();
      } else {
        const refs = this.$refs as unknown as {payModal: {showModal: Function}};
        refs.payModal.showModal();
      }
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat
    background-size 100% 100%
    height 100vh
    width 100%
    overflow: hidden;
</style>
